<div class="submenu-complex-left">
    <nav class="nav overflow-y-hidden">
        <div class="d-flex flex-column gap-3 w-100 h-100">
            <div class="col-auto h-100 ms-3 mb-2">
                <list
                    id="department-list"
                    [clippedBody]="false"
                    [clippedSearch]="true"
                    [allowMultiSelect]="data().allowMultiSelect()"
                    (selectedEntity)="data().select($event)"
                    [filterEntities]="departmentsFilter.coreSignal"
                    [entities]="filteredDepartments()"
                    [template]="departmentNodeTemplate"></list>
            </div>
        </div>
    </nav>
</div>

<ng-template
    #departmentNodeTemplate
    let-securableNode="item">
        <item-small-generic                 
        class="font-5 p-1 py-2 b-bottom"
        [ngClass]="{ 'text-faded': !securableNode['isHovering'] }"                                                                       
        (mouseenter)="securableNode['isHovering'] = true" 
        (mouseleave)="securableNode['isHovering'] = false"                                        
        isSelectable="true"
        [currentItem]="securableNode"
        [template]="departmentTemplate"/>
</ng-template>

<ng-template
    #departmentTemplate    
    let-securable="item">
        <presenter class="department-item"
            [data]="securable.value" />
</ng-template>
